// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mG","tag":"mH","isRental":"mI","title":"mJ","title2":"mK","description":"mL","cta":"mM","ratingLabel":"mN","ratingLabelSmallScreen":"mO","iconInHotspotVideo":"mP"};